export default "__VITE_ASSET__t2MdlB_D__"